import { render, staticRenderFns } from "./UpdateRoleWindow.vue?vue&type=template&id=3031d8a0"
import script from "./UpdateRoleWindow.vue?vue&type=script&lang=js"
export * from "./UpdateRoleWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports